define('views/shared/form/form_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/form_component.html',
    'views/shared/form/input/text_component',
    'views/shared/form/input/text_group_component',
    'views/shared/form/input/address_component',
    'views/shared/form/input/city_component',
    'views/shared/form/input/state_component',
    'views/shared/form/input/zipcode_component',
    'views/shared/form/input/number_component',
    'views/shared/form/input/member_id_component',
    'views/shared/form/input/phone_component',
    'views/shared/form/input/birthdate_component',
    'views/shared/form/input/email_component',
    'views/shared/form/input/email_mute_component',
    'views/shared/form/input/password_component',
    'views/shared/form/input/checkbox_component',
    'views/shared/form/input/ssn_component',
    'views/shared/form/input/invite_code_component',
    'views/shared/button/button',
    'deepmerge'
], function(Backbone, BaseView, Template, TextComponent, TextGroupComponent, AddressComponent, CityComponent, StateComponent, ZipcodeComponent, NumberComponent, MemberIdComponent, PhoneComponent, BirthdateComponent, EmailComponent, EmailMuteComponent, PasswordComponent, CheckboxComponent, SSNComponent, InviteCodeComponent, ButtonComponent, Merge){
    'use strict';

    return BaseView.extend({
        className: 'form-component-container',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.context = options.context || {};
            this.validated = options.validated || {};
            this.success = options.success || {};
            this.error = options.error || {};

            this.inline_error = false;

            this.form_type = (options.form_type) ? options.form_type : 0;
            this.form_page = (options.form_page == undefined) ? null : options.form_page;;
            this.feature = options.feature;
            this.content_fields = options.content_fields;
            this.fields = (options.fields) ? options.fields : [];
            this.route = options.route;
            this.button_data = options.button_data;

            this.active_fields = [];
            this.process_complete = null;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){
            // Load Form groups
                /*
                    Form Group
                        - Takes one to many input types
                            - Input Type accepts
                                - Name
                                - Placeholder
                                - Value
                                - 
                                - Options (Optional)
                        - Takes one submit endpoint
                */


            // Initiate first Form group and progress to each Form group until complete

            // If there are no Form groups, load generic Form group

            this.render();

            this.addInlineErrorField();

            if(this.form_type == enums.formType.features && _.isObject(this.feature)){

                this.buildFormFromFeatures();

            } else {

                this.addFields();

            }

            this.addButton();

        },

        addInlineErrorField: function(){

            if(_.isObject(this.button_data)){
                
                if(_.isBoolean(this.button_data.errors_inline) && this.button_data.errors_inline == true){
                    
                    this.$('.js-form').append('<div class="inline-form-error js-inline-form-error"></div>');

                }
                
            }

        },

        showInlineErrorMessage: function(){

            if(_.isObject(this.form_button)){

                this.inline_error = true;

                this.$('.js-inline-form-error').addClass('visible').html(this.form_button.btn_error_message);

            }

        },

        showInlineTopErrorMessage: function(){

            if(_.isObject(this.form_button)){

                this.inline_error = true;

                this.$('.js-form').prepend('<div class="inline-form-error visible js-inline-form-error">' + this.form_button.btn_error_message + '</div>');

            }

        },

        buildFormFromFeatures: function(){

            var that = this;

            if(_.isObject(this.feature)){
                var features = this.feature.features;
            } else {
                var features = null;
            }

            if(_.isArray(features)){

                var groupings = [];

                features.forEach(function(field){

                    // Get each fields content conterpart and then merge
                    var field_content = pf.getContent(that.content_fields, 'object', { id: field.id });

                    // Merge with features content
                    var final_field = Merge(field_content, field);

                    // If the field is part of a group, then add it to the appropriate group
                    if(_.isObject(final_field.group)){

                        // final_field.group.type
                        if(groupings.length > 0){

                            var group = groupings.filter(function(group){ return group.group_id = final_field.group.group_id })[0];

                        } else {

                            var group = {
                                type      : final_field.group.type,
                                group_id  : final_field.group.group_id,
                                element   : 'group',
                                input_type: final_field.group.input_type,
                                component_type: final_field.group.component_type,
                                fields    : []
                            }

                        }

                        group.fields.push(final_field);

                        groupings.push(group);

                        if(final_field.group.end){
                            that.fields.push(group);
                            groupings = [];
                        }

                    } else {

                        that.fields.push(final_field);

                    }

                });

                this.addFields();

            }

        },

        addFields: function(){
            var that = this;

            if(_.isArray(this.fields)){

                this.fields.forEach(function(field, index){

                    switch(field.component_type){
                        case enums.formComponentTypes.member_id:
                            var input_field = new NumberComponent({ field: field });
                            break;
                        case enums.formComponentTypes.member_id_alphanumeric:
                            var input_field = new MemberIdComponent({ field: field });
                            break;
                        case enums.formComponentTypes.street_address:
                            var input_field = new AddressComponent({ field: field });
                            break;
                        case enums.formComponentTypes.city:
                            var input_field = new CityComponent({ field: field });
                            break;
                        case enums.formComponentTypes.state:
                            var input_field = new StateComponent({ field: field });
                            break;
                        case enums.formComponentTypes.zipcode:
                            var input_field = new ZipcodeComponent({ field: field });
                            break;
                        case enums.formComponentTypes.full_name_group:
                            var input_field = new TextGroupComponent({ fields: field.fields });
                            break;
                        case enums.formComponentTypes.date_of_birth:
                            var input_field = new BirthdateComponent({ field: field });
                            break;
                        case enums.formComponentTypes.phone:
                            var input_field = new PhoneComponent({ field: field });
                            break;
                        case enums.formComponentTypes.email:
                            var input_field = new EmailComponent({ field: field });
                            break;
                        case enums.formComponentTypes.email_mute:
                            var input_field = new EmailMuteComponent({ field: field });
                            break;
                        case enums.formComponentTypes.password:
                            var input_field = new PasswordComponent({ field: field });
                            break;
                        case enums.formComponentTypes.invite_code:
                            var input_field = new InviteCodeComponent({ field: field });
                            break;
                        case enums.formComponentTypes.terms:
                            var input_field = new CheckboxComponent({ field: field });
                            break;
                        case enums.formComponentTypes.marketing:
                            var input_field = new CheckboxComponent({ field: field, is_valid: true });
                        case enums.formComponentTypes.oiwp:
                            var input_field = new CheckboxComponent({ field: field, is_valid: true });
                        break;
                        case enums.formComponentTypes.ssn:
                            var input_field = new SSNComponent({ field: field });
                            break;
                        case enums.formComponentTypes.sms:
                            var input_field = new CheckboxComponent({ field: field, is_valid: true });
                            break;
                        default:
                            var input_field = null;
                            break;
                    };

                    if(input_field){
                        that.active_fields.push(input_field);
                        that.$('.js-form').append(input_field.el);
                    }

                });

            }

        },

        removeField: function(component_type){

            if(_.isArray(this.active_fields)){

                var that = this;

                this.active_fields.forEach(function(field, index){

                    if(field.is_group){

                        var inner_active_fields = field.active_fields;

                        if(_.isArray(inner_active_fields)){

                            inner_active_fields.forEach(function(inner_field, inner_index){

                                if(inner_field.field.component_type == component_type){

                                    inner_field.$el.remove();

                                    that.inner_active_fields.splice(inner_index, 1);

                                    if(that.inner_active_fields.length == 0){
                                        that.active_fields.splice(index, 1);
                                    }

                                }

                            });

                        }

                    } else if(!field.is_group && field.field.component_type == component_type){

                        field.$el.remove();

                        that.active_fields.splice(index, 1);

                    }

                });

            }

        },

        addButton: function(){

            var that = this;

            // TODO: Create fallback functions that do things

            if(this.button_data){

                this.button_data.calling_view = this;

                this.button_data.btn_callback = function(processComplete){
                    that.validateForm(processComplete);
                };

                this.button_data.btn_success_callback = function(){
                    that.continueFormSuccess();
                };

                this.button_data.btn_error_callback = function(){
                    that.formError();
                };

                this.form_button = new ButtonComponent(this.button_data);

                this.$('.js-form').append(this.form_button.el);

            }

        },

        validateForm: function(processComplete){
            var that = this;

            if(_.isArray(this.active_fields)){

                var errors = [],
                    group = [];

                this.process_complete = processComplete;

                this.active_fields.forEach(function(field, index){

                    // If the field{} is not valid
                    if(!field.is_valid && !field.soft_error){

                        if(field.field){
                            
                            // If the field{} is available then find out if it is required
                            var field_required = field.field.required;

                        } else if(field.fields && field.is_group){
                            
                            // If the field is a group then get the correct field{} from the fields[] group to find out if it is required
                            var nested_field = field.fields[group.length],
                                field_required = nested_field.required;

                            if(_.isObject(nested_field.group)){

                                if(nested_field.group.end){
                                    group = [];
                                } else {
                                    group.push(nested_field);
                                }

                            }

                        } else {
                            var field_required = false;
                        }

                        var optional_field = (_.isBoolean(field.empty) && field.empty == true && !field_required) ? true : false;

                        if(field.field){

                            if(_.isBoolean(field.field.empty) && field.field.empty == true && !field_required){
                                optional_field = true;
                            }

                        }

                        // If the field{} is not optional, then add it to the errors[] list
                        if(!optional_field){

                            errors.push(field);

                            if(_.isFunction(field.showError)){
                                field.showError();
                            }

                        }
                        
                    } else if(field.is_valid && !field.soft_error){

                        // If field{} is valid, then remove error in case the is one showing
                        if(_.isFunction(field.removeError)){
                            field.removeError();
                        }

                    }

                });

                if(errors.length == 0){

                    // Let the calling view know that the form is valid and update button with completion state
                    if(_.isFunction(this.validated)){

                        // If there are inline errors, then remove them
                        if(_.isBoolean(this.button_data.errors_inline) && this.button_data.errors_inline == true){
                    
                            this.$('.js-inline-form-error').removeClass('visible').html('');

                        }

                        this.validated(this.active_fields, function(valid){
                            that.acknowledgedValidation(valid, that.process_complete);
                        });

                    }

                } else {

                    // Cancel the button process
                    if(_.isFunction(this.form_button.cancelProcess)){
                        this.form_button.cancelProcess();
                    }

                    // Inform calling view of the field errors that occured
                    if(_.isFunction(this.error)){
                        this.error(errors);
                    }

                }

            }

        },

        acknowledgedValidation: function(valid, process_complete){

            if(!_.isBoolean(valid)){

                valid = false;

            }

            if(this.inline_error){
                
                // Cancel the button process to allow inline error process to resolve itself
                if(_.isFunction(this.form_button.cancelProcess)){
                    this.form_button.cancelProcess();
                }

                this.inline_error = false;

            } else {

                if(!this.process_complete){
                    this.process_complete = process_complete;
                }

                if(this.process_complete && this.process_complete.name){
                    this.form_button[this.process_complete.name](valid);
                } else {
                    this.process_complete(valid, this.form_button);
                }

            }

        },

        continueFormSuccess: function(){

            if(_.isFunction(this.success)){
                this.success();
            }

        },

        formError: function(){

            if(_.isFunction(this.error)){
                this.error();
            }

        },

        getField: function(component_type){

            var that = this,
                return_field = null;

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    if(field.is_group){

                        var inner_active_fields = field.active_fields;

                        if(_.isArray(inner_active_fields)){

                            inner_active_fields.forEach(function(inner_field, inner_index){

                                if(inner_field.field.component_type == component_type){

                                    return_field = inner_field;

                                }

                            });

                        }

                    } else if(!field.is_group && field.field.component_type == component_type){

                        return_field = field;

                    }

                });

            }

            return return_field;

        },

        getFieldValues: function(){

            var that = this,
                values = {};

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    if(field.is_valid && field.is_group){

                        var group_list = field.active_fields;

                        if(_.isArray(group_list)){

                            group_list.forEach(function(group_item){

                                if(_.isFunction(group_item.getValue)){

                                    var val = group_item.getValue();

                                    if(group_item.field.values == 2){

                                        values[group_item.field.name] = val.one;
                                        values[group_item.field.name_two] = val.two;

                                    } else {
                                        values[group_item.field.name] = val;
                                    }

                                }

                            });

                        }

                    } else if(field.is_valid || field.soft_error){

                        if(_.isFunction(field.getValue)){
                            
                            var val = field.getValue();

                            if(field.field.values == 2){

                                values[field.field.name] = val.one;
                                values[field.field.name_two] = val.two;

                            } else {
                                values[field.field.name] = val;
                            }

                        }

                    }

                });

            }

            return values;

        },

        updateFieldValue: function(component_type, new_value, sub_component_type){

            var that = this,
                updated = false;

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    if(field.is_group){

                        var inner_active_fields = field.active_fields;

                        if(_.isArray(inner_active_fields)){

                            inner_active_fields.forEach(function(inner_field, index){

                                if(inner_field.field.component_type == component_type && _.isFunction(inner_field.updateValue)){

                                    inner_field.updateValue(new_value, sub_component_type);
                                    updated = true;

                                }

                            });

                        }

                    } else {

                        if(field.field.component_type == component_type && _.isFunction(field.updateValue)){

                            field.updateValue(new_value, sub_component_type);
                            updated = true;

                        }

                    }

                });

            }

            return updated;

        },

        removeFieldValidation: function(component_type, enum_value){

            var that = this,
                updated = false;

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    if(field.is_group){

                        var inner_active_fields = field.active_fields;

                        if(_.isArray(inner_active_fields)){

                            inner_active_fields.forEach(function(inner_field, index){

                                if(inner_field.field.component_type == component_type && _.isFunction(inner_field.removeFieldValidation)){

                                    inner_field.removeFieldValidation(enum_value);
                                    updated = true;

                                }

                            });

                        }

                    } else {

                        if(field.field.component_type == component_type && _.isFunction(field.removeFieldValidation)){

                            field.removeFieldValidation(enum_value);
                            updated = true;

                        }

                    }

                });

            }

            return updated;

        },

        updateErrorMessage: function(val){

            if(_.isFunction(this.form_button.updateErrorMessage)){
                this.form_button.updateErrorMessage(val);
            }
            
        },

        showFieldError: function(component_type, outline_error){

            var that = this,
                updated = false;

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    if(field.is_group){

                        var inner_active_fields = field.active_fields;

                        if(_.isArray(inner_active_fields)){

                            inner_active_fields.forEach(function(inner_field, index){

                                if(inner_field.field.component_type == component_type && _.isFunction(inner_field.showError)){

                                    inner_field.is_valid = false;
                                    
                                    if(outline_error){
                                        inner_field.showDataMatchingError();
                                    } else {
                                        inner_field.showError();
                                    }
                                    
                                    updated = true;

                                }

                            });

                        }

                    } else {

                        if(field.field.component_type == component_type && _.isFunction(field.showError)){

                            field.is_valid = false;

                            if(outline_error){
                                field.showDataMatchingError();
                            } else {
                                field.showError();
                            }

                            updated = true;

                        }

                    }

                });

            }

            return updated;

        },

        resetForm: function(){

            var that = this,
                form_reset = true;

            if(_.isArray(this.active_fields)){

                this.active_fields.forEach(function(field, index){

                    if(field.is_group){

                        var inner_active_fields = field.active_fields;

                        if(_.isArray(inner_active_fields)){

                            inner_active_fields.forEach(function(inner_field, index){

                                if(_.isFunction(inner_field.reset)){

                                    inner_field.reset();

                                } else {
                                    form_reset = false;
                                }

                            });

                        }

                    } else {

                        if(_.isFunction(field.reset)){

                            field.reset();

                        } else {
                            form_reset = false;
                        }

                    }

                });

            }

            return form_reset;

        },

        close: function(){}
    });
});
